import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from 'common/components/errorBoundary';
import { ForgotPasswordPage } from 'features/LoginSession/pages/forgotPasswordPage';

export const Route = createFileRoute('/spaces/(auth)/forgot-password')({
  component: () => (
    <ErrorBoundary>
      <ForgotPasswordPage />
    </ErrorBoundary>
  ),
});
